import { useTranslation } from 'react-i18next';

import type { DealKind } from '@/lib/db/deals';
import './StatusPill.css';

export type StatusPillProps = {
  status: DealKind;
};

const STATUS_KEY: Record<DealKind, string> = {
  READY: 'common:dealStatus.ready',
  'OFF-PLAN': 'common:dealStatus.offPlan',
  SOLD: 'common:dealStatus.sold',
};

const STATUS_CLASS: Record<DealKind, string> = {
  READY: 'status-pill--ready',
  'OFF-PLAN': 'status-pill--offplan',
  SOLD: 'status-pill--sold',
};

export function StatusPill({ status }: StatusPillProps) {
  const { t } = useTranslation();
  return <span className={`status-pill ${STATUS_CLASS[status]}`}>{t(STATUS_KEY[status])}</span>;
}
